import type { ButtonProps } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { AppButton } from "../../../../../shared/components/AppButton";
import { FolderIcon } from "../../../../../shared/icons/FolderIcon";
import styles from "../styles.module.css";

interface Props extends ButtonProps {
  handleCreateFolder: () => void;
  isDisabled?: boolean;
}

export const CreateFolderButton: FC<Props> = ({
  handleCreateFolder,
  isDisabled,
  ...props
}) => {
  const { t } = useTranslation();
  return (
    <AppButton
      buttonType={"text"}
      onClick={handleCreateFolder}
      disabled={isDisabled}
      className={styles["add-folder-button"]}
      {...props}
    >
      <FolderIcon />
    </AppButton>
  );
};
